import React, {Component, Fragment} from "react";
import NAB_RYPRow from "./row/NAB_RYPRow";

class NAB_RYPTreeTable extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
        }
        this.handlerClickNode = this.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }

    handlerClickNode = () => {
        const {isExpanded} = this.state;
        this.setState({isExpanded: !isExpanded});
    }

    render() {
        const {marginLeft, node} = this.props;
        const {isExpanded} = this.state;
        return (
            <Fragment>
                <NAB_RYPRow key={node?.nodeId} data={node?.data} isExpanded={isExpanded} marginLeftValue={marginLeft} hasChild={!!node?.children && node?.children.length > 0?true:false} handlerClickNode={this.handlerClickNode} handlerSetIsLoading={this.handlerSetIsLoading}/>
                {!!node?.children && node?.children.map(item =>isExpanded && <NAB_RYPTreeTable key={item?.nodeId} node={item} marginLeft={marginLeft + 30} handlerSetIsLoading={this.handlerSetIsLoading}/>)}
            </Fragment>
        )
    }
}
export default NAB_RYPTreeTable;